import { ReactNode, useEffect, useState } from "react";
import { FilterFormFieldStrategyType } from "../types";
import { Collapse, Select } from "antd";
import FormItem from "antd/es/form/FormItem";
import { cn } from "../utils";
import { RangeSlider } from "@/components";
import CheapFormComponent from "@/components/form/CheapFormComponent";
import Typography from "@/components/Typography/Typography";

const { Option } = Select;

export default function useGenerateFilterFormElements(
  strategy: FilterFormFieldStrategyType[]
) {
  const [filterElements, setFilterElements] = useState<ReactNode[]>([]);
  if (!strategy) throw new Error("No strategy provided for render");
  const generateFilterElement = (el: FilterFormFieldStrategyType) => {
    switch (el.element.inputType) {
      case "checkboxGroup":
        return (
          <Collapse
            key={el.element.name}
            className="bg-primaryDim !min-w-fit !border-none"
            destroyInactivePanel
            items={[
              {
                label: (
                  <Typography
                    type="p"
                    fontFamily="font-kanit"
                    fontWeight="font-medium"
                  >
                    {el.key}
                  </Typography>
                ),
                children: (
                  <FormItem
                    name={el.element.name}
                    initialValue={[]}
                    className={cn("", el.element.formItemClassName)}
                    getValueProps={(value) => ({ value })}
                    getValueFromEvent={(value) => value}
                  >
                    <CheapFormComponent
                      name={el.element.name}
                      options={el.element.options ? el.element.options : []}
                    />
                  </FormItem>
                ),
              },
            ]}
          />
        );
      case "range":
        return (
          <Collapse
            key={el.element.name}
            className="bg-primaryDim min-w-fit !border-none"
            destroyInactivePanel
            items={[
              {
                label: (
                  <Typography
                    type="p"
                    fontFamily="font-kanit"
                    fontWeight="font-medium"
                  >
                    {el.key}
                  </Typography>
                ),
                children: (
                  <label
                    className={cn(el.element.wrapperClassName)}
                    key={el.element.wrapperClassName}
                  >
                    <FormItem
                      name={el.element.name}
                      initialValue={[el.element.rangeMin, el.element.rangeMax]}
                      className={cn("", el.element.formItemClassName)}
                      // rules={[
                      //   {
                      //     required: el.required,
                      //     message: "This field is required",
                      //   },
                      //   {
                      //     pattern: el.pattern || undefined,
                      //     message: el.patternMessage || undefined,
                      //   },
                      // ]}
                      getValueProps={(value) => {
                        return {
                          value: value ?? [
                            el.element.rangeMin,
                            el.element.rangeMax,
                          ],
                        };
                      }}
                      getValueFromEvent={(value) => {
                        return value;
                      }}
                    >
                      <RangeSlider
                        min={el.element.rangeMin as number}
                        max={el.element.rangeMax as number}
                      />
                    </FormItem>
                  </label>
                ),
              },
            ]}
          />
        );
      case "select":
        return (
          <label
            className={cn("min-w-full", el.element.wrapperClassName)}
            key={el.element.name}
          >
            <Typography
              type="span"
              fontFamily="font-kanit"
              fontWeight="font-medium"
            >
              {el.element.label}
            </Typography>
            <FormItem
              validateTrigger="onBlur"
              name={el.element.name}
              initialValue={
                el.element.defaultValue ? el.element.defaultValue : ""
              }
              className={cn("", el.element.formItemClassName)}
              rules={[
                {
                  required: el.element.required,
                  message: "This field is required",
                },
                {
                  pattern: el.element.pattern || undefined,
                  message: el.element.patternMessage || undefined,
                },
              ]}
            >
              <Select
                value={el.element.defaultValue}
                disabled={el.element.readonly}
                removeIcon={el.element.readonly}
                className={cn(
                  "custom-select-antd text-base h-[46px] font-kanit !border-none rounded-lg w-full !bg-primaryDim",
                  el.element.selectClassElement
                )}
                variant="filled"
                // style={{
                //   backgroundColor: "#F3F9FC",
                // }}
              >
                {el.element.options &&
                  el.element.options?.map((option) => (
                    <Option value={option.value} key={option.label}>
                      <Typography
                        type="span"
                        fontFamily="font-kanit"
                        textColor="black"
                        fontWeight="font-light"
                      >
                        {option.label}
                      </Typography>
                    </Option>
                  ))}
              </Select>
            </FormItem>
          </label>
        );
      default:
        break;
    }
  };
  useEffect(() => {
    setFilterElements(() => strategy.map((el) => generateFilterElement(el)));
  }, [strategy]);
  return filterElements;
}
